import { gql } from '@apollo/client';

const GET_DEVICE_LISTS = gql`
    query Query($deviceId: Int) {
        getUniqueDevicesList(device_id: $deviceId)
    }
`;

export { GET_DEVICE_LISTS };
